export var initialWindowMetrics = null;

/**
 * @deprecated
 */
export var initialWindowSafeAreaInsets = null;